import Notice from '@components/Notice'

export default {
  path: 'noticeList',
  component: Notice,
  stat: '消息列表/首页'
}
